import * as _ from "lodash";
import { observable, makeObservable } from "mobx";
import authStore from "../../authStore";
import {
  decryptShareLink,
  doSendMessage,
  getContacts,
  getConversationInfo,
  postOpsLog,
} from "../../serviceCalls";
import "./ShareLinkModal.scss";
import { translateShareLinkToRoute } from "./ShareLinkUtils";

export default class ShareLinkStore {
  data = {};
  loading;
  loadingContacts;
  contacts;
  contact;
  postOpsLog = postOpsLog;

  constructor() {
    makeObservable(this, {
      data: observable,
      loading: observable,
      loadingContacts: observable,
      contacts: observable,
      contact: observable,
    });

    this.changeContact = this.changeContact.bind(this);
  }
  /**
   * Decrypts ShareLink from backend
   */
  decryptShareLink(location) {
    let requestBody = {
      launchUrl: `airstripone://${_.last(
        location.pathname.split("sharelink/"),
      )}${location.search}`,
    };
    this.loading = true;
    return decryptShareLink(requestBody)
      .then((res) => {
        const authToken = res.xAuthToken;
        const username = res.adUserName;
        authStore.login({
          authToken,
          username,
        });
        return translateShareLinkToRoute({
          url: res.shareLinkUrl,
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }

  fetchContacts() {
    this.loadingContacts = true;
    return getContacts()
      .then(
        (res) =>
          (this.contacts = res.map((contact) => ({
            label: contact.name,
            value: contact,
          }))),
      )
      .finally(() => (this.loadingContacts = false));
  }
  changeContact(contact) {
    this.contact = contact;
  }
  postMessage(message) {
    this.loadingContacts = true;
    return getConversationInfo({
      recipientContactId: this.contact.value.contactId,
    })
      .then((convo) =>
        doSendMessage({
          conversationId: convo.conversationId,
          messages: [encodeURI(message)],
        }),
      )
      .finally(() => (this.loadingContacts = false));
  }
}
